import { render, staticRenderFns } from "./MenuConfigNew.vue?vue&type=template&id=fc50edb8&scoped=true"
import script from "./MenuConfigNew.vue?vue&type=script&lang=js"
export * from "./MenuConfigNew.vue?vue&type=script&lang=js"
import style0 from "./MenuConfigNew.vue?vue&type=style&index=0&id=fc50edb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc50edb8",
  null
  
)

export default component.exports